import 'assets/css/index.min.css'
import 'select2/dist/css/select2.min.css'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'react-notification-alert/dist/animate.css'
import 'react-perfect-scrollbar/dist/css/styles.css'

// BagSpa frontend-only responsive patch.
// Keep this after theme/vendor CSS so it can safely override layout styles.
import './assets/css/bagspa-responsive-lite.css'

import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import AppWrapper from './app-wrapper.jsx'
import * as serviceWorker from './serviceWorker'

ReactDOM.render(
  <BrowserRouter>
    <AppWrapper />
  </BrowserRouter>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
